<template>
  <BaseModal modalColor="border-success bg-primary" iconModal="fa fa-edit" subtitulo="Cadastrar nova saida"
             col-md="col-md-5" offset="offset-3">
    <template v-slot:modalContent>
      <form ref="cadastroForm" @submit.prevent="submitIncluirForm">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.construcao"
                    inputId="construcao"
                    :options="construcoes"
                    optionLabel="imovel"
                    optionValue="id"
                    size="small"
                    appendTo="body"
                    filter
                    style="width: 100%"
                    :invalid="campoVazio.includes('construcao')"
                >
                  <template #emptyfilter>
                    Nenhum resultado encontrado
                  </template>
                </Select>
                <label for="imovel">
                  <strong>Construção:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_cadastro" v-model="dado.data_cadastro" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataCadastro" dateFormat="dd/mm/yyyy"
                            :invalid="campoVazio.includes('data_cadastro')"/>
                <label for="data_inicio"><strong>Data Cadastro: <span
                    class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_entrega" v-model="dado.data_entrega" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataEntrega" dateFormat="dd/mm/yyyy"
                            :invalid="campoVazio.includes('data_entrega')"/>
                <label for="data_entrega"><strong>Data Entrega: <span
                    class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="observacao" v-model="dado.observacao" size="small" style="width: 100%"/>
                <label for="observacao"><strong>Observação: </strong></label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="$emit('fechar')">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest, denormalizeDates} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "CadastrarSaidas",
  components: {
    BaseModal,
  },
  data() {
    return {
      construcoes: [],
      dado: {
        construcao: "",
        data_cadastro: "",
        data_entrega: "",
        observacao: "",
        usuario: "user",
      },
      campoVazio: [],
    }
  },
  emits: ["fechar", "atualizarLista"],
  methods: {
    async getConstrucao() {
      const resultado = await apiRequest("GET", apiUrl.construcoes.createList);
      if (resultado.success) {
        this.construcoes = resultado.data.results;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },

    async submitIncluirForm() {
      denormalizeDates(this.dado, ['data_cadastro', 'data_entrega']);
      const resultado = await apiRequest("POST", apiUrl.saidas.createList, this.dado);
      if (resultado.success) {
        this.$emit("atualizarLista", resultado.data);
        this.$toastMessage("success", "Registro salvo com sucesso!");
        this.$emit('fechar');
      } else {
        this.campoVazio = Object.keys(resultado.error);
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  mounted() {
    this.getConstrucao();
    Inputmask("99/99/9999").mask(this.$refs.dataCadastro.$el.querySelector("input"));
    Inputmask("99/99/9999").mask(this.$refs.dataEntrega.$el.querySelector("input"));
  }
}
</script>
